export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14758.4b844590.jpg";